import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export const NoSchedulesTodayMessage = () => (
  <div className="Schedule__message">
    <FormattedMessage id="schedule.no-results" defaultMessage="There are no upcoming classes on this day" />
  </div>
);

export const NoSchedulesSelectedDateMessage = ({ date }) => (
  <div className="Schedule__header-message">
    <FormattedMessage id="schedule.noClasses" defaultMessage="There are no classes {date}." values={{ date }} />
  </div>
);

NoSchedulesSelectedDateMessage.propTypes = {
  date: PropTypes.node.isRequired,
};

export const NoSchedulesOfClassTodayMessage = ({ nameOfClass }) => (
  <div className="Schedule__message">
    <FormattedMessage
      id="schedule.no-results-for-class"
      defaultMessage="There are no upcoming “{nameOfClass}” classes on this day."
      values={{ nameOfClass }}
    />
  </div>
);

NoSchedulesOfClassTodayMessage.propTypes = {
  nameOfClass: PropTypes.string.isRequired,
};

export const SchedulesErrorMessage = ({ onClick }) => (
  <div className="Schedule__message">
    <FormattedMessage id="schedule.error-loading" defaultMessage="There was an error loading the schedule." />
    <p className="mt">
      <button onClick={onClick} className="bt bt--tertiary bt--width-md">
        <FormattedMessage id="schedule.error-loading.retry" defaultMessage="Retry" />
      </button>
    </p>
  </div>
);

SchedulesErrorMessage.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export const SchedulesSkeleton = () => (
  <div className="Schedule__skeleton">
    <div>
      <div className="Schedule__skeleton__content Schedule__skeleton__content--narrow mb-" />
      <div className="Schedule__skeleton__content Schedule__skeleton__content--narrow" />
    </div>
    <div className="Schedule__skeleton__content__center-column">
      <div className="Schedule__skeleton__content mb-" />
      <div className="Schedule__skeleton__content Schedule__skeleton__content--full-width" />
    </div>
    <div className="Schedule__skeleton__content Schedule__skeleton__content--two-rows" />
  </div>
);

export const SchedulesAlert = ({ children }) => <div className="Schedule__alert-message">{children}</div>;

SchedulesAlert.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]).isRequired,
};

export const NextCycleMessage = () => (
  <SchedulesAlert>
    <FormattedMessage id="schedule.nextCycle" defaultMessage="You are viewing classes in your next cycle" />
  </SchedulesAlert>
);
